"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVouchersCountEndpoint = void 0;
const giveaways_constants_1 = require("root/src/shared/giveaways/giveaways.constants");
const auth_1 = require("root/src/shared/constants/auth");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
exports.getVouchersCountEndpoint = {
    [giveaways_constants_1.giveawayEndpointIds.GET_VOUCHERS_COUNT]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.creator,
        payloadSchema: {
            type: 'object',
            properties: {
                giveawayOwnerId: {
                    type: 'string',
                },
            },
        },
        endpointType: lenses_1.otherEndpointType,
    },
};
